import { CheckedIcon, WarningIcon } from 'assets/icons';
import { NavLink } from 'react-router-dom';

export interface ISubNavItemProps {
  name: string;
  path: string;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  isValid?: boolean;
}

export default function SubNavItem(props: ISubNavItemProps) {
  const { name, path, isValid } = props;
  return (
    <nav>
      <NavLink
        className={({ isActive }) =>
          isActive
            ? 'flex items-center py-2 rounded-md text-green justify-between'
            : 'flex items-center py-2 rounded-md text-gray-200 justify-between'
        }
        to={path}
      >
        <span className="text-sm font-normal mr-4">{name}</span>
        {isValid === false && <WarningIcon className="w-4 h-4" />}

        {isValid === true && <CheckedIcon className="w-4 h-4" />}
      </NavLink>
    </nav>
  );
}
